import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentWithArrowDownToLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 7v4.6l-1.3-1.3a.996.996 0 1 0-1.41 1.41l3 3c.198.188.444.287.7.29h-.01.02-.01a.98.98 0 0 0 .7-.29l3-3a.996.996 0 1 0-1.41-1.41L13 11.58V7c0-.55-.45-1-1-1s-1 .45-1 1M8 17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 22c-.55 0-1-.45-1-1V7a1 1 0 0 1 .076-.38q.076-.184.214-.33l4-4A1 1 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1zM7 5.41 6.41 6H7zM5 8h3c.55 0 1-.45 1-1V4h10v16H5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocumentWithArrowDownToLine;
